import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {useApolloClient} from '@apollo/client'
import {Box} from '@mui/material'
import {PGButton, PGModal, PGTypography} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

import {SESSION_EXPIRED_EVENT} from '@progyny/const/sessionExpiredEvent'
import {RouteEnum, useRoutes} from '@progyny/routes'
import {useMeStore} from '@progyny/store/meStore'

const useStyles = makeStyles()(() => ({
  modal: {
    '& .MuiDialog-paper': {
      maxWidth: 400,
      width: '100%',
    },
  },
}))

const SessionExpiredModal: React.FC = () => {
  const {t} = useTranslation()
  const history = useHistory()
  const {getPath} = useRoutes()
  const {classes} = useStyles()
  const isLoggedIn = useMeStore((s) => s.isLoggedIn)
  const apollo = useApolloClient()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const handleSessionExpired = () => {
      if (isLoggedIn) {
        setIsOpen(true)
      }
    }

    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired)

    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired)
    }
  }, [isLoggedIn])

  const handleLogin = () => {
    setIsOpen(false)
    apollo.clearStore().finally(() => {
      history.push(
        `${getPath(RouteEnum.LOGIN)}?next=${encodeURI(window.location.pathname)}`
      )
    })
  }

  return (
    <PGModal
      open={isOpen}
      onClose={handleLogin}
      title={t('session_expired_modal_title')}
      showCloseButton={false}
      className={classes.modal}
    >
      <Box display='flex' flexDirection='column' alignItems='center' gap={2}>
        <PGTypography variant='body' textAlign='center'>
          {t('session_expired_modal_message')}
        </PGTypography>
        <PGButton
          variant='contained'
          label={t('routes_nav_login')}
          onClick={handleLogin}
        />
      </Box>
    </PGModal>
  )
}

export default SessionExpiredModal
